module.exports = __webpack_public_path__ + "img/level-down-alt.95e49c1b.svg";